import { createFeatureSelector, createSelector } from '@ngrx/store';

import { RowSelectionItem } from 'app/shared/features/map-row-selector/models';
import { rowSelectionFeatureKey } from 'app/state/row-selection/row-selection.reducer';

import { RowSelectionState } from './row-selection.state';

export const getRowSelectionState = createFeatureSelector<RowSelectionState>(rowSelectionFeatureKey);

export const getSelectedRows = createSelector(getRowSelectionState, (state: RowSelectionState) => state.rows);

export const getRowSelectionByRowNumberList = (rowNumbers: number[]) =>
    createSelector(getSelectedRows, (selectedRows) =>
        rowNumbers
            .map((rowNumber) => selectedRows.find((i) => i.rowNumber === rowNumber))
            .filter((rowSelectionItem): rowSelectionItem is RowSelectionItem => !!rowSelectionItem),
    );

export const getRowSelectionByRowNumber = (rowNumber: number) =>
    createSelector(getSelectedRows, (selectedRows) => selectedRows.find((i) => i.rowNumber === rowNumber));

export const getRowSelectionStatusByRowNumber = (rowNumber: number) =>
    createSelector(getRowSelectionByRowNumber(rowNumber), (item) => item?.registrationStatus);

export const rowSelectionProgressState = createSelector(getRowSelectionState, (state: RowSelectionState) => {
    return state.selectionProgressState;
});

export const isRowSelectionInProgress = createSelector(rowSelectionProgressState, (progressState) => {
    return progressState === 'in-progress';
});

export const isRowSelectionFinished = createSelector(rowSelectionProgressState, (progressState) => {
    return progressState === 'finished';
});
